import { NavLink } from 'react-router-dom';
import { hapticSelection } from '../lib/telegram';

export default function BottomNav({ isAdmin }: { isAdmin: boolean }) {
  const items = [
    { to: '/', label: 'Каталог', icon: '🛒', end: true },
    { to: '/sell', label: 'Продать', icon: '➕', end: false },
    { to: '/profile', label: 'Профиль', icon: '👤', end: false },
    ...(isAdmin ? [{ to: '/admin', label: 'Админ', icon: '🛡️', end: false }] : []),
  ];

  return (
    <nav className="fixed inset-x-0 bottom-0 z-40 flex justify-center border-t border-mlbb-border bg-mlbb-bg/95 backdrop-blur-sm">
      <div className="flex w-full max-w-md">
        {items.map((item) => (
          <NavLink
            key={item.to}
            to={item.to}
            end={item.end}
            onClick={() => hapticSelection()}
            className={({ isActive }) =>
              `flex flex-1 flex-col items-center gap-0.5 py-2 text-xs ${
                isActive ? 'text-white' : 'text-white/40'
              }`
            }
          >
            <span className="text-lg">{item.icon}</span>
            {item.label}
          </NavLink>
        ))}
      </div>
    </nav>
  );
}
